import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { downloadSessionSummaryPdf } from '@/api/sessionSummaries/sessionSummariesApi';
import { saveDownloadedFile, type DownloadedFile } from '@/api/fileDownload';

export function useDownloadSummaryPdf(): UseMutationResult<DownloadedFile, Error, string> {
  return useMutation({
    mutationFn: function requestSummaryPdf(noteId: string) {
      return downloadSessionSummaryPdf(noteId);
    },
    onSuccess: saveDownloadedFile,
  });
}

export function useViewSummaryPdf(): UseMutationResult<DownloadedFile, Error, string> {
  return useMutation({
    mutationFn: function requestSummaryPdf(noteId: string) {
      return downloadSessionSummaryPdf(noteId);
    },
  });
}
